import React from "react";
import { DatePicker } from "antd";
import "./datePicker.scss";

const CommonDatePicker = ({
  label,
  value,
  onChange,
  format = "YYYY-MM-DD",
  placeholder = "Select Date",
  disabled = false,
  showTime = false,
  ...props
}) => {
  return (
    <div className="common-date-picker">
      {label && <label className="date-picker-label">{label}</label>}
      <DatePicker
        value={value}
        onChange={(date, dateString) => onChange(dateString)}
        format={format}
        placeholder={placeholder}
        disabled={disabled}
        showTime={showTime}
        style={{ width: "100%" }} // Makes it responsive
        {...props}
      />
    </div>
  );
};

export default CommonDatePicker;
